export const SET_INTERNAL_REVIEWS = "setInternalReviews"

export default {
  [SET_INTERNAL_REVIEWS](state: InternalReviewsState, internalReviews: InternalReview[]) {
    state.internalReviews = internalReviews
  }
}
